// src/PublicUser/components/BlogNavbar.jsx
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import '../../css/BlogNavbar.css';

const BlogNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`ts-blog-nav ${scrolled ? 'ts-scrolled' : ''}`}>
      <div className="ts-blog-nav-container">
        {/* Logo Section */}
        <div className="ts-blog-nav-brand">
          <a href="/" className="ts-blog-logo">
            <div className="ts-logo-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 4L4 10L16 16L28 10L16 4Z" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <path d="M4 16L16 22L28 16" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <path d="M4 22L16 28L28 22" stroke="url(#gradient)" strokeWidth="2" fill="none"/>
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#00D4FF"/>
                    <stop offset="100%" stopColor="#7B2FF7"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <span className="ts-blog-logo-text">TechShara</span>
            <span className="ts-blog-badge">Blog</span>
          </a>
        </div>

        {/* Desktop Navigation Links */}
        <div className={`ts-blog-nav-links ${isMenuOpen ? 'ts-mobile-open' : ''}`}>
          <ul className="ts-blog-nav-menu">

            <li>
              <NavLink
                to="/blog"
                className={({ isActive }) =>
                  "ts-blog-nav-link " + (isActive ? "ts-active" : "")
                }
              >
                Blog
              </NavLink>
            </li>
                <li>
                  <NavLink
                    to="/learning-zone"
                    className={({ isActive }) =>
                      "ts-blog-nav-link " + (isActive ? "ts-active" : "")
                    }
                  >
                    Tutorials
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/tools"
                    className={({ isActive }) =>
                      "ts-blog-nav-link " + (isActive ? "ts-active" : "")
                    }
                  >
                    Free AI Tools
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/certifications"
                    className={({ isActive }) =>
                      "ts-blog-nav-link " + (isActive ? "ts-active" : "")
                    }
                  >
                    Free Certifications
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/language-translator"
                    className={({ isActive }) =>
                      "ts-blog-nav-link " + (isActive ? "ts-active" : "")
                    }
                  >
                    Multi-Language Translator
                  </NavLink>
                </li>
            </ul>

          {/* Right side actions */}
          <div className="ts-blog-nav-actions">            
            <a href="/" className="ts-blog-cta">
              <span>Back to Home</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19 12H5M5 12L11 6M5 12L11 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Mobile Hamburger */}
        <button 
          className={`ts-blog-hamburger ${isMenuOpen ? 'ts-open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default BlogNavbar;